import { useEffect, useState } from 'react';
import { preferencesService } from '../../auth/service/preferencesService';
import { subscribePreferencesChanged } from '../../auth/service/preferencesEvents';

/** Limita a espera inicial para manter a navegação disponível. */
export const SIDEBAR_ORDER_INITIAL_WAIT_MS = 2000;

/** null indica a primeira leitura pendente; falha ou demora usam a ordem padrão. */
export function useSidebarOrder(userId: string | undefined): string[] | null {
  const [snapshot, setSnapshot] = useState<{ userId: string | undefined; order: string[] | null }>(
    () => ({ userId, order: null }),
  );
  useEffect(() => {
    let epoch = 0;
    let loaded = false;
    const setOrder = (order: string[] | null) => setSnapshot({ userId, order });
    setOrder(null);
    const timeout = window.setTimeout(() => {
      if (!loaded) {
        loaded = true;
        epoch++;
        setOrder([]);
      }
    }, SIDEBAR_ORDER_INITIAL_WAIT_MS);
    const refresh = () => {
      const request = ++epoch;
      preferencesService.getPreferences().then(preferences => {
        if (request === epoch) { loaded = true; window.clearTimeout(timeout); setOrder(preferences.sidebar_order ?? []); }
      }).catch(() => {
        if (request === epoch && !loaded) { loaded = true; window.clearTimeout(timeout); setOrder([]); }
      });
    };
    refresh();
    const unsubscribe = subscribePreferencesChanged(refresh);
    return () => { epoch++; window.clearTimeout(timeout); unsubscribe(); };
  }, [userId]);
  return snapshot.userId === userId ? snapshot.order : null;
}
